import { apiSlice } from "features/api/apiSlice";

const cancelAppointment = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    cancelAppointment: build.mutation({
      query: ({ id, reason }) => ({
        url: `/appointments/cancel/${id}`,
        method: "PUT",
        body: { reason },
      }),
      transformResponse: (res) => res.d,
      invalidatesTags: (result) => [{ type: "Appointment", id: result.id }],
    }),
  }),
});

export const { useCancelAppointmentMutation } = cancelAppointment;
